<template>
  <el-dialog
    v-if="vsebinaPogodbe !== ''"
    append-to-body
    :show-close="false"
    :close-on-press-escape="false"
    :visible.sync="prikaziDialog"
    :title="naslov">
      <div style="text-align: center">
        <span v-html="vsebinaPogodbe" style="display: flex; text-align: center; justify-content: center;"/>
        <div style="padding-top: 100px;">
          <el-checkbox v-model="potrditevSplosnihPogojev">
            Izjavljam, da sem prebral in se strinjam s splošnimi pogoji.
          </el-checkbox>
        </div>
        <div>
          <a :href="splosniPogojiPodjetja">
            <img src="/static/img/MojT2/Dokumenti/Icon-awesome-file-download.png">
            Splošni pogoji
          </a>
        </div>
      </div>
    <template #footer>
      <span class="dialog-footer" style="padding-top: 50px">
        <el-button type="primary" @click="NarociPaket" :disabled="potrditevSplosnihPogojev === false">
          ŽELIM NAROČITI TRŽNI PAKET
        </el-button>
        <el-button @click="ZapriDialog">
          Prekliči
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import {Dialog, Button} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent'

export default {
  name: 'PrikazPogodbe',
  data () {
    return {
      paket: null,
      idUgodnost: null,
      naslov: '',
      vsebinaPogodbe: '',
      potrditevSplosnihPogojev: false,
      hitrostPaketa: null
    }
  },
  props: {
    podatkiPogodbe: {
      default: null
    },
    izbranPrikljucek: {
      type: String
    },
    prikaziDialog: {
      type: Boolean,
      default: false
    },
    splosniPogojiPodjetja: {
      default: null
    }
  },
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button
  },
  mounted () {
    this.clientAgent = new ClientAgent()
  },
  watch: {
    podatkiPogodbe: function (val) {
      this.paket = val.paket
      this.hitrostPaketa = val.idHitrost
      this.naslov = 'Naročilo na tržni paket: ' + this.paket.naziv
      this.idUgodnost = val.idUgodnost
      if (this.izbranPrikljucek !== '') {
        if (this.idUgodnost !== null) {
          this.vsebinaPogodbe = ''
          let param = []
          param.push('idPrikljucek=' + this.izbranPrikljucek)
          param.push('idStoritevVrsta=' + this.idUgodnost)
          this.clientAgent.postWsRequest(
            this,
            'dokumenti/aneksi/pridobiAneks',
            param,
            null,
            'SetPrikazPogodbe',
            '')
        }
      }
    }
  },
  methods: {
    ZapriDialog () {
      this.$emit('resetVrednostiDialoga')
    },
    NarociPaket () {
      if (this.potrditevSplosnihPogojev) {
        this.$emit('potrjenaIzvajaSplosnihPogojev', this.paket, this.hitrostPaketa, this.idUgodnost)
        this.ZapriDialog()
      }
    },
    SetPrikazPogodbe (podatki) {
      if (podatki !== null) {
        this.vsebinaPogodbe = podatki.data
      } else {
        let paramObvestilo = {}
        paramObvestilo.message = 'Za poljuben paket je potrebno izbrati internetno hitrost.'
        this.ShowWarningMessage(paramObvestilo)
      }
    },
    ObravnavajStrinjanjeSPogojiPosrednik () {
      if (this.strinjanjeSPogojiPosrednik === '1') {
        let gumb = document.getElementsByClassName('popup-potrditev-trzi-paket-button')[0]
        if (typeof gumb !== 'undefined') {
          gumb.style = ''
          gumb.disabled = false
        }
      } else {
        let gumb = document.getElementsByClassName('popup-potrditev-trzi-paket-button')[0]
        if (typeof gumb !== 'undefined') {
          gumb.style = 'background-color: #d8dce6 !important; color: var(--white); border: 1px solid white !important'
          gumb.disabled = true
        }
      }
    }
  }
}
</script>

<style scoped>

.main {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/PrikazPogodbe.vue